export const PRIVACY_BLUR_CLASSNAME = 'blur-sm select-none';
